export const websiteJsonLd = ({ url, name, searchUrl }) => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  url,
  name,
  potentialAction: searchUrl
    ? {
        "@type": "SearchAction",
        target: `${searchUrl}?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      }
    : undefined,
});

export const organizationJsonLd = ({ url, name, logo, sameAs = [] }) => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  url,
  name,
  logo,
  sameAs,
});

export const breadcrumbJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: it.item,
  })),
});

export const itemListJsonLd = (products) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  itemListElement: products.map((p, i) => ({
    "@type": "ListItem",
    position: i + 1,
    url: p.url,
    name: p.name,
    item: {
      "@type": "Product",
      name: p.name,
      image: p.image,
      brand: p.brand ? { "@type": "Brand", name: p.brand } : undefined,
      category: p.category,
      offers: p.price
        ? {
            "@type": "Offer",
            priceCurrency: p.currency || "EUR",
            price: p.price,
            availability: p.inStock === false ? "https://schema.org/OutOfStock" : "https://schema.org/InStock",
            url: p.url,
          }
        : undefined,
    },
  })),
});

